import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit {
  email = null;
  constructor(
    private router: Router,
    private auth: AuthService,
    private toastr: ToastrService
  ) {
    auth.getUser().subscribe((user) => {
      // extract email out of the current user object logged in
      console.log('USER IS: ', user);
      this.email = user?.email;
    });
  }

  ngOnInit(): void {}

  handleSignOut = async () => {
    try {
      await this.auth.signOut();
      this.router.navigateByUrl('/signin');
      this.toastr.info('Logout Successfull');
      this.email = null;
    } catch (err) {
      this.toastr.error('Problem in SignOut');
    }
  };
}
